export default function ThongTinThuChi({ data, formatNumber }) {
    return (<>
        <div className="form-body form-bordered-2 row-store">
            <div className="row col-md-12 ">
                <div className="col-md-12">
                    <div className="form-group last-1">
                        <div className="row" style={{ padding: "20px" }}>
                            <div className="col-md-6 color7-bold">Thu hợp đồng</div>
                            <div className="col-md-6 color-xanh-bold  text-right">
                                {formatNumber(Math.round(data.ThuHopDong))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group last-1">
                        <div className="row" style={{ padding: "20px" }}>
                            <div className="col-md-6 color7-bold">Chi hợp đồng</div>
                            <div className="col-md-6 color-do-bold  text-right">
                                {formatNumber(Math.round(data.ChiHopDong))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group last-1">
                        <div className="row" style={{ padding: "20px" }}>
                            <div className="col-md-6 color7-bold">Tổng tiền khách nợ</div>
                            <div className="col-md-6 color-do-bold  text-right">
                                {formatNumber(Math.round(data.TongTienKhachNo))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group last-1">
                        <div className="row" style={{ padding: "20px" }}>
                            <div className="col-md-6 color7-bold">Thu ngoài lề</div>
                            <div className="col-md-6 color-xanh-bold  text-right">
                                {formatNumber(Math.round(data.ThuNgoaiLe))}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-md-12">
                    <div className="form-group last-1">
                        <div className="row" style={{ padding: "20px" }}>
                            <div className="col-md-6 color7-bold">Chi ngoài lề</div>
                            <div className="col-md-6 color-do-bold  text-right">
                                {formatNumber(Math.round(data.ChiNgoaiLe))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}